export default {
  buttons: {
    sign_in: 'Entrar',
    sign_up: 'Registar',
    logout: 'Terminar sessão',
  },
  logout_confirm: {
    title: 'Terminar sessão?',
    description: 'Tem a certeza de que pretende terminar sessão?',
    cancel: 'Cancelar',
    confirm: 'Terminar sessão',
  },
};
